<template>
  <div class="simple-coin-container">
    <!-- 金币显示区域 -->
    <div class="simple-coin-display" :class="{ 'coin-bounce': isAnimating }">
      <!-- 简约金币图标 -->
      <div class="simple-coin-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" fill="#FFD700" stroke="#FF8C00" stroke-width="1.5"/>
          <text x="12" y="15" text-anchor="middle" font-size="7" font-weight="bold" fill="#FFF">¥</text>
        </svg>
      </div>

      <!-- 金币数量 -->
      <div class="simple-coin-amount">
        <span class="simple-amount-number">{{ formattedAmount }}</span>
      </div>
    </div>

    <!-- 金币飞入效果 -->
    <div v-for="(coin, index) in flyingCoins" :key="index" class="flying-coin" :style="coin.style">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" fill="#FFD700"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleCoinDisplay',
  props: {
    initialAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 直接显示目标值
      targetAmount: this.initialAmount,
      isAnimating: false,
      flyingCoins: [],
      animationFrame: null
    }
  },
  computed: {
    // 直接显示实际数字，保留两位小数
    formattedAmount() {
      return parseFloat(this.targetAmount).toFixed(2)
    }
  },
 // 【新增】监听父组件传来的金额变化
  watch: {
    initialAmount(newVal) {
      // 当外部金额发生变化时，同步更新内部要显示的金额
      this.targetAmount = parseFloat(newVal);
    }
  },
  mounted() {
    this.startAnimationLoop()
  },

  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
  },

  methods: {
    startAnimationLoop() {
      const update = () => {
        // 只更新飞行金币动画
        this.updateFlyingCoins()
        this.animationFrame = requestAnimationFrame(update)
      }
      update()
    },

    updateFlyingCoins() {
      for (let i = this.flyingCoins.length - 1; i >= 0; i--) {
        const coin = this.flyingCoins[i]
        coin.progress += 0.05

        if (coin.progress >= 1) {
          this.flyingCoins.splice(i, 1)
          continue
        }

        const t = coin.progress
        const endX = 320
        const endY = 50

        // 简单线性飞行路径
        const x = coin.startX + (endX - coin.startX) * t
        const y = coin.startY + (endY - coin.startY) * t

        coin.style = {
          left: x + 'px',
          top: y + 'px',
          opacity: 1 - t * 0.7,
          transform: `scale(${0.5 + t * 0.5})`,
          'z-index': 1002
        }
      }
    },

    // 触发金币奖励
    addCoins(amount) {
      this.targetAmount = parseFloat((parseFloat(this.targetAmount) + parseFloat(amount)).toFixed(2))
      this.isAnimating = true
      setTimeout(() => this.isAnimating = false, 300)
      this.createFlyingCoins(3)
    },

    // 创建飞行金币
    createFlyingCoins(count = 3) {
      for (let i = 0; i < count; i++) {
        const startX = -20
        const startY = Math.random() * (window.innerHeight - 100) + 50

        this.flyingCoins.push({
          startX,
          startY,
          progress: 0,
          delay: i * 0.1,
          style: {
            left: startX + 'px',
            top: startY + 'px',
            opacity: 0,
            transform: 'scale(0.5)',
            'z-index': 1002
          }
        })

        // 延迟启动每枚金币的动画
        setTimeout(() => {
          const index = this.flyingCoins.findIndex(c => c.startY === startY && c.startX === startX)
          if (index !== -1) {
            this.flyingCoins[index].progress = 0.01
          }
        }, i * 100)
      }
    },

    // 从外部更新金币数量
    // updateAmount(newAmount) {
    //   this.targetAmount = parseFloat(newAmount).toFixed(2)
    // },

    // 手动触发奖励（用于测试）
    triggerReward(amount = 100) {
      this.addCoins(amount)
    }
  }
}
</script>

<style scoped>
.simple-coin-container {
  position: fixed;
  top: 40px;
  right: 0px;
  z-index: 1001;
  pointer-events: none;
  user-select: none;
}

.simple-coin-display {
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  background: rgba(0, 0, 0, 0.25);
  /*border-radius: 20px;*/
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 215, 0, 0.3);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}

.simple-coin-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.simple-coin-amount {
  min-width: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.simple-amount-number {
  font-size: 16px;
  font-weight: 600;
  color: #FFD700;
  font-family: 'Arial', sans-serif;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  letter-spacing: 0.5px;
}

/* 金币跳动动画 */
.coin-bounce {
  animation: coinBounce 0.3s ease;
}

@keyframes coinBounce {
  0% { transform: scale(1); }
  50% { transform: scale(1.08); }
  100% { transform: scale(1); }
}

/* 飞行金币动画 */
.flying-coin {
  position: fixed;
  pointer-events: none;
  z-index: 1002;
  opacity: 0;
  will-change: transform, opacity, left, top;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}
</style>